import React, {PureComponent} from 'react';
import {connect} from 'react-redux'
import cn from "classnames"
import injectSheet from 'react-jss'
import {toggleMenu} from "../actions/menu"
import {getMenuIsOpen} from "../selectors/menu"
import {TimelineLite, Power2} from "gsap"

const height = 38;
const width = 24;
const thickness = 1;

class Hamburger extends PureComponent {

    _openMenu = (e) => {
        const {handleToggleMenu} = this.props;
        handleToggleMenu();
        e.preventDefault();
        return false
    }

    componentDidUpdate() {

        const t = new TimelineLite()
        var duration = 0.3;
        if (this.props.open) {
            t.to(this.bar1, duration/2, {top: 18})
                .to(this.bar3, duration/2, {top: 18}, '0')
                .to(this.bar1, duration*2, {rotation: 225, ease: Power2.easeOut}, `${duration/2}`)
                .to(this.bar2, duration*2, {rotation: 225, ease: Power2.easeOut}, `${duration/2}`)
                .to(this.bar3, duration*2, {rotation: 315, ease: Power2.easeOut}, `${duration/2}`)
        } else {

            t.to(this.bar1, duration*2, {rotation: 0, ease: Power2.easeOut}, '0')
                .to(this.bar2, duration*2, {rotation: 0, ease: Power2.easeOut}, '0')
                .to(this.bar3, duration*2, {rotation: 0, ease: Power2.easeOut}, '0')
                .to(this.bar3, duration/2, {top: 26}, `${duration*2}`)
                .to(this.bar1, duration/2, {top: 10}, `${duration*2}`)

        }
    }

    _setBar1 = ref => this.bar1 = ref;
    _setBar2 = ref => this.bar2 = ref;
    _setBar3 = ref => this.bar3 = ref;

    render() {
        const {classes, className} = this.props;
        return (
            <div className={cn(classes.container, className)} onClick={this._openMenu}>
                <div className={classes.bar} ref={this._setBar1} />
                <div className={cn(classes.bar, classes.bar2)} ref={this._setBar2} />
                <div className={cn(classes.bar, classes.bar3)} ref={this._setBar3} />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        open: getMenuIsOpen(state)
    }
}


function mapDispatchToProps(dispatch) {
    return {
        handleToggleMenu: () => {
            dispatch(toggleMenu())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)( injectSheet( (theme) => (
    {
        container: {
            position: 'relative',
            display: 'inline-block',
            cursor: 'pointer',
            width: width,
            height: height,
        },
        bar: {
            width: width,
            position: 'absolute',
            left: 7,
            top: 10,
            height: thickness,
            backgroundColor: theme.colors.white,
        },
        bar2: {
            width: width,
            top: 18,
        },
        bar3: {
            top: 26,
        },
    }
))(Hamburger) );



// WEBPACK FOOTER //
// ./src/components/Hamburger.js